export default __webpack_public_path__ + "static/media/Roboto-Medium.13a29228.ttf";